/* Being Wear fit guide pop-up. Loads being-size-data.json from theme assets, then starts the tool. */
(function(){
  const dataUrl = document.currentScript && document.currentScript.dataset.src;
  if(!dataUrl){ console.error('[BeingSizer] add data-src=\"{{ \'being-size-data.json\' | asset_url }}\" to the script tag'); return; }
  fetch(dataUrl).then(r => r.json()).then(function(DATA){
    (function(){
      'use strict';
  

      // ---------- configuration ----------
      const CONFIG = {
        product: 'bottoms',        // 'bottoms' | 'tops' , set from the product page (e.g. product.type)
        showUnverified: false,      // set false on the live site until each brand is checked
        maxResults: 6,
        onMeasureInstead: () => console.log('[BeingSizer] open the tape-measure option'),
        onSelectSize: (size) => console.log('[BeingSizer] select variant', size),
        onNoMatch: (query) => { (window.dataLayer = window.dataLayer || []).push({event:'size_converter_no_match', query}); console.log('[BeingSizer] no brand match for:', query); }
      };

      // ---------- helpers ----------
      const $ = (id) => document.getElementById(id);
      const norm = (s) => s.toLowerCase().replace(/[’']/g,'').replace(/&/g,' and ').replace(/[^a-z0-9]+/g,' ').trim();

      function visibleLines(brand){
        return brand.lines.filter(l => l.product === CONFIG.product && (CONFIG.showUnverified || l.verified || l.measureInstead));
      }
      function searchBrands(q){
        const n = norm(q); if(!n) return [];
        const words = n.split(' ');
        const scored = [];
        for(const b of DATA.brands){
          if(!visibleLines(b).length) continue;
          const names = [b.name, ...b.aliases].map(norm);
          let score = 0;
          for(const nm of names){
            if(nm === n) score = Math.max(score, 100);
            else if(nm.startsWith(n)) score = Math.max(score, 80);
            else if(nm.split(' ').some(w => words.every(qw => nm.split(' ').some(nw => nw.startsWith(qw))))) score = Math.max(score, 60);
            else if(nm.includes(n)) score = Math.max(score, 40);
          }
          if(score) scored.push({b, score});
        }
        return scored.sort((x,y) => y.score - x.score || x.b.rank - y.b.rank).slice(0, CONFIG.maxResults).map(x => x.b);
      }
      function bandFor(measure, cm){
        const bands = DATA.bands[measure];
        if(cm < bands[0].lo) return {below:true, edge:bands[0]};
        if(cm > bands[bands.length-1].hi) return {above:true, edge:bands[bands.length-1]};
        return bands.find(b => cm >= b.lo && cm < b.hi + 1);   // bands are whole-cm and non-overlapping; fractional values fall into the band below the next lower bound
      }
      const measureWord = {waist:'waist', bust:'chest', underbust:'under-bust'};
      const displayBand = (b) => b.printed || (b.lo + '-' + b.hi);

      // ---------- state & rendering ----------
      let brand = null, line = null;
      const el = {root:$('bw-sizer'), input:$('bw-brand-input'), results:$('bw-brand-results'), stepLine:$('bw-step-line'), lineChips:$('bw-line-chips'),
        stepSize:$('bw-step-size'), sizeChips:$('bw-size-chips'), result:$('bw-result'), measure:$('bw-measure'), size:$('bw-size'), note:$('bw-note'), cta:{}, reset:$('bw-reset')};
      let activeIdx = -1, lastQuery = '';

      function searchOtherTab(q){
        const other = CONFIG.product === 'tops' ? 'bottoms' : 'tops';
        const n = norm(q); if(!n) return null;
        return DATA.brands.find(b => b.lines.some(l => l.product === other && (CONFIG.showUnverified || l.verified || l.measureInstead)) && [b.name, ...b.aliases].map(norm).some(nm => nm === n || nm.startsWith(n) || nm.includes(n))) || null;
      }
      function renderResults(list){
        el.results.innerHTML = '';
        activeIdx = -1;
        if(!list.length){
          const other = searchOtherTab(el.input.value);
          if(other && window.BeingSizer && BeingSizer.setProduct){
            const otherTab = CONFIG.product === 'tops' ? 'bottoms' : 'bralettes & binders';
            const li = document.createElement('li'); li.style.cursor = 'pointer';
            li.innerHTML = '<span>' + other.name + ' is under <u>' + otherTab + '</u></span><small>switch</small>';
            li.addEventListener('mousedown', (e) => { e.preventDefault(); const q = el.input.value; BeingSizer.setProduct(CONFIG.product === 'tops' ? 'bottoms' : 'tops'); BeingSizer.open(); el.input.value = q; el.input.dispatchEvent(new Event('input')); document.getElementById('bw-opt-brand') && (document.getElementById('bw-opt-brand').open = true); document.getElementById('bw-opt-tbrand') && CONFIG.product === 'tops' && (document.getElementById('bw-opt-tbrand').open = true); });
            el.results.appendChild(li); el.results.hidden = false; return;
          }
          el.results.hidden = true; return;
        }
        list.forEach((b,i) => {
          const li = document.createElement('li'); li.role = 'option'; li.dataset.id = b.id;
          const cat = b.category === 'binder' ? 'binders' : '';
          li.innerHTML = '<span>' + b.name + (visibleLines(b).some(l=>!l.verified) ? '<span class="bw-flag" title="Size ranges for this brand were filled in from standard regional sizing or general knowledge, not read from the brand\u2019s own size chart. Hidden from customers until checked."' + (CONFIG.showUnverified?'':' hidden') + '>unverified</span>' : '') + '</span><small>' + cat + '</small>';
          li.addEventListener('mousedown', (e) => { e.preventDefault(); chooseBrand(b); });
          el.results.appendChild(li);
        });
        el.results.hidden = false;
      }
      function chooseBrand(b){
        brand = b; line = null;
        el.input.value = b.name; el.results.hidden = true;
        el.result.hidden = true; el.stepSize.hidden = true; el.reset.hidden = false;
        const lines = visibleLines(b);
        if(lines.length > 1){
          el.lineChips.innerHTML = '';
          lines.forEach(l => {
            const btn = document.createElement('button'); btn.type='button'; btn.className='bw-chip'; btn.textContent = l.name; btn.setAttribute('aria-pressed','false');
            btn.addEventListener('click', () => { [...el.lineChips.children].forEach(c=>c.setAttribute('aria-pressed','false')); btn.setAttribute('aria-pressed','true'); chooseLine(l); });
            el.lineChips.appendChild(btn);
          });
          el.stepLine.hidden = false;
          el.lineChips.firstChild.focus();
        } else { el.stepLine.hidden = true; chooseLine(lines[0]); }
      }
      function chooseLine(l){
        line = l; el.result.hidden = true;
        if(l.measureInstead || !l.sizes.length){
          el.stepSize.hidden = true;
          showResult({special:'measure'}); return;
        }
        el.sizeChips.innerHTML = '';
        l.sizes.forEach(s => {
          const btn = document.createElement('button'); btn.type='button'; btn.className='bw-chip'; btn.textContent = s.label; btn.setAttribute('aria-pressed','false');
          btn.addEventListener('click', () => { [...el.sizeChips.children].forEach(c=>c.setAttribute('aria-pressed','false')); btn.setAttribute('aria-pressed','true'); showResult({size:s}); });
          el.sizeChips.appendChild(btn);
        });
        el.stepSize.hidden = false;
        if(!el.stepLine.hidden) return; // keep focus on line chip user just pressed
        el.sizeChips.firstChild.focus();
      }
      function showResult(o){
        el.result.hidden = false;
    
        if(o.special === 'measure'){
          el.measure.textContent = brand.name + ' sizes don\u2019t convert to other brands.';
          el.size.textContent = 'Measure instead';
          el.note.textContent = line.note ? shortNote(line.note) : 'Their sizing is made to measure or set by their own fit tool, so a label size doesn\u2019t tell us your measurements. A tape measure takes about a minute.';
          el.cta.textContent = 'Measure myself'; el.cta.onclick = () => CONFIG.onMeasureInstead();
          return;
        }
        const s = o.size, mid = (s.lo + s.hi) / 2, band = bandFor(line.measure, mid);
        if(s.override){
          const ob = DATA.bands[line.measure].find(b => b.size === s.override);
          const byMeasure = (band && !band.below && !band.above) ? 'Being ' + band.size : 'a different size';
          el.measure.textContent = 'On ' + brand.name + '\u2019s own measurements, a ' + brand.name + ' ' + s.label + ' would be ' + byMeasure + '.';
          el.size.innerHTML = 'Being ' + ob.size + '<span>' + displayBand(ob) + ' cm ' + measureWord[line.measure] + '</span>';
          el.note.textContent = 'But from customer feedback and our own research, we know a ' + brand.name + ' ' + s.label + ' fits a Being ' + ob.size + '.';
          return;
        }
        const bodyPart = measureWord[line.measure];
        const rangeTxt = (s.lo === s.hi) ? s.lo + ' cm' : s.lo + '-' + s.hi + ' cm';
        el.measure.textContent = 'A ' + brand.name + ' ' + line.name.replace(/\s*\(.*?\)/,'').toLowerCase() + ' ' + s.label + ' fits a ' + bodyPart + ' of about ' + rangeTxt + '.';
        if(band.below || band.above){
          el.size.textContent = band.below ? 'Smaller than our ' + band.edge.size : 'Larger than our ' + band.edge.size;
          el.note.textContent = band.below ? 'Our smallest size fits a ' + bodyPart + ' from ' + band.edge.lo + ' cm. If you\u2019re close, measure and try the ' + band.edge.size + '.' : 'Our largest size fits a ' + bodyPart + ' up to ' + band.edge.hi + ' cm.';
          el.cta.textContent = 'Measure myself'; el.cta.onclick = () => CONFIG.onMeasureInstead();
          return;
        }
        // Which Being bands does this brand range cover by at least 2 cm? One → single size; more → show the span.
        const covered = DATA.bands[line.measure].filter(b => Math.min(s.hi, b.hi) - Math.max(s.lo, b.lo) + 1 >= 2);
        const bandLo = covered[0], bandHi = covered[covered.length - 1];
        const straddles = covered.length > 1;
        if(straddles){
          const all = DATA.bands[line.measure]; const i1 = all.indexOf(bandLo), i2 = all.indexOf(bandHi);
          const label = (i2 - i1 === 1) ? bandLo.size + ' or ' + bandHi.size : bandLo.size + ' to ' + bandHi.size;
          el.size.innerHTML = 'Being ' + label + '<span>' + displayBand(bandLo).split('-')[0] + '-' + displayBand(bandHi).split('-')[1] + ' cm ' + bodyPart + '</span>';
        } else {
          el.size.innerHTML = 'Being ' + band.size + '<span>' + displayBand(band) + ' cm ' + bodyPart + '</span>';
        }
        let note = straddles
          ? 'This ' + brand.name + ' size covers more than one of our sizes. If you know your ' + bodyPart + ' measurement, use it to pick; otherwise take the larger one.'
          : 'Our sizes are set by measurement, so the letter may be different from what you\u2019re used to. Between two sizes? Take the larger one.';
        if(line.product === 'tops' && line.measure === 'underbust') note = 'Cup size doesn\u2019t change your Being size. For a binder, also measure your full chest and go up a size if it\u2019s more than 12 cm over your under-bust.';
        if(/runs small/i.test(line.note || '')) note = brand.name + ' runs small, so if you were between sizes there, take the smaller Being size.';
        el.note.textContent = note;
        el.cta.textContent = 'Choose ' + band.size; el.cta.onclick = () => CONFIG.onSelectSize(band.size);
      }
      const shortNote = (n) => n.split(/(?<=\.)\s/)[0];

      // ---------- events ----------
      el.input.addEventListener('input', () => {
        brand = null; line = null; el.stepLine.hidden = true; el.stepSize.hidden = true; el.result.hidden = true; el.reset.hidden = !el.input.value;
        lastQuery = el.input.value;
        renderResults(searchBrands(lastQuery));
      });
      el.input.addEventListener('keydown', (e) => {
        const items = [...el.results.children];
        if(e.key === 'ArrowDown' || e.key === 'ArrowUp'){
          if(el.results.hidden) return;
          e.preventDefault();
          activeIdx = (activeIdx + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
          items.forEach((li,i) => li.setAttribute('aria-selected', i === activeIdx));
        } else if(e.key === 'Enter'){
          const pick = items[activeIdx] || items[0];
          if(pick){ chooseBrand(DATA.brands.find(b => b.id === pick.dataset.id)); }
        } else if(e.key === 'Escape'){ el.results.hidden = true; }
      });
      el.input.addEventListener('blur', () => { setTimeout(() => { el.results.hidden = true; if(!brand && lastQuery.trim().length >= 2 && !searchOtherTab(lastQuery)) CONFIG.onNoMatch(lastQuery.trim()); }, 120); });
      $('bw-measure-instead').addEventListener('click', () => CONFIG.onMeasureInstead());
      el.reset.addEventListener('click', () => { el.input.value = ''; el.input.dispatchEvent(new Event('input')); el.input.focus(); });
      el.root.querySelectorAll('[data-bw-close]').forEach(x => x.addEventListener('click', close));
      document.addEventListener('keydown', (e) => { if(e.key === 'Escape' && el.root.open) close(); });

      function open(opts){ Object.assign(CONFIG, opts || {}); el.root.setAttribute('open',''); el.root.open = true; document.body.style.overflow = 'hidden'; el.input.focus(); }
      function close(){ el.root.removeAttribute('open'); el.root.open = false; document.body.style.overflow = ''; }

      window.BeingSizer = { open, close, config: CONFIG, search: searchBrands };

      })();


    /* ---- Options 1, 3 and 4: measurement inputs, sharing the same bands and result style ---- */
    (function(){
  
      const $ = (id) => document.getElementById(id);
      const waist = DATA.bands.waist;
      // Garment flat waist, edge to edge (cm), from the master chart. Option 3 picks the nearest.
      const FLAT = {'5XS':23,'4XS':25,'3XS':28,'2XS':30,'XS':32,'S':34,'M':36,'L':38,'XL':40,'2XL':42,'3XL':44,'4XL':48.5,'5XL':50,'6XL':53,'7XL':55};
      const bandByWaist = (cm) => waist.find(b => cm >= b.lo && cm <= b.hi);
      const show = (prefix, o) => {
        $(prefix+'-result').hidden = false;
        $(prefix+'-measure').textContent = o.measure || '';
        $(prefix+'-size').innerHTML = o.size;
        $(prefix+'-note').textContent = o.note || '';
    
      };
      const select = (size) => BeingSizer.config.onSelectSize(size);
      function fromWaist(prefix, cm, srcText){
        if(!(cm > 0)) { $(prefix+'-result').hidden = true; return; }
        const first = waist[0], last = waist[waist.length-1];
        if(cm < first.lo) return show(prefix,{measure:srcText, size:'Smaller than our '+first.size, note:'Our smallest size fits a waist from '+first.lo+' cm. If you\u2019re close, try the '+first.size+'.'});
        if(cm > last.hi) return show(prefix,{measure:srcText, size:'Larger than our '+last.size, note:'Our largest size fits a waist up to '+last.hi+' cm.'});
        const b = bandByWaist(cm);
        show(prefix,{measure:srcText, size:'Being '+b.size+'<span>'+b.printed+' cm waist</span>', note: (cm===b.lo?'You\u2019re right on the line, so we\u2019ve given you the larger size. ':'')+'Between two sizes? Take the larger one.', cta:'Choose '+b.size, onClick:()=>select(b.size)});
      }
      const unitOf = (wrap) => wrap.querySelector('[aria-pressed="true"]').dataset.unit;
      // Switching units converts whatever is already typed (80 cm -> 31.5 in) so the answer doesn't change
      document.querySelectorAll('.bw-unit').forEach(u => u.querySelectorAll('button').forEach(btn => btn.addEventListener('click', () => {
        const from = unitOf(u), to = btn.dataset.unit, input = u.closest('.bw-opt__body').querySelector('input');
        if(from !== to){
          const v = parseFloat(input.value);
          if(v > 0) input.value = to === 'in' ? +(v / 2.54).toFixed(1) : +(v * 2.54).toFixed(1);
          input.placeholder = to === 'in' ? 'e.g. ' + (+(parseFloat(input.dataset.egCm || input.placeholder.replace(/\D/g,'')) / 2.54).toFixed(1)) : 'e.g. ' + input.dataset.egCm;
        }
        u.querySelectorAll('button').forEach(x => x.setAttribute('aria-pressed', x===btn)); input.dispatchEvent(new Event('input'));
      })));
      document.querySelectorAll('.bw-num input[placeholder]').forEach(i => i.dataset.egCm = i.placeholder.replace(/\D/g,''));
      const toCm = (val, unit) => unit === 'in' ? val * 2.54 : val;

      // 1 ─ label
      $('bw-label-cm').addEventListener('input', (e) => fromWaist('bw-label', parseFloat(e.target.value), 'Your label says about '+e.target.value+' cm.'));
      // 3 ─ flat
      $('bw-flat-val').addEventListener('input', (e) => {
        const raw = parseFloat(e.target.value), unit = unitOf(e.target.closest('.bw-num').querySelector('.bw-unit'));
        if(!(raw > 0)) { $('bw-flat-result').hidden = true; return; }
        const cm = toCm(raw, unit);
        const entries = Object.entries(FLAT);
        if(cm < entries[0][1] - 1.5) return show('bw-flat',{measure:'Flat across the waistband: '+cm.toFixed(1)+' cm.', size:'Smaller than our 5XS', note:'Our smallest size measures about '+entries[0][1]+' cm flat.'});
        if(cm > entries[entries.length-1][1] + 1.5) return show('bw-flat',{measure:'Flat across the waistband: '+cm.toFixed(1)+' cm.', size:'Larger than our 7XL', note:'Our largest size measures about '+entries[entries.length-1][1]+' cm flat.'});
        let best = entries[0]; for(const en of entries){ if(Math.abs(en[1]-cm) < Math.abs(best[1]-cm)) best = en; }
        const band = waist.find(b => b.size === best[0]);
        show('bw-flat',{measure:'Flat across the waistband: '+cm.toFixed(1)+' cm. Our '+best[0]+' measures about '+best[1]+' cm flat.', size:'Being '+best[0]+'<span>'+band.printed+' cm waist</span>', note:'Stretch fabrics vary, so this is a guide. If your current pair feels tight, go up one.', cta:'Choose '+best[0], onClick:()=>select(best[0])});
      });
      // 4 ─ tape
      $('bw-tape-val').addEventListener('input', (e) => {
        const raw = parseFloat(e.target.value), unit = unitOf(e.target.closest('.bw-num').querySelector('.bw-unit'));
        const cm = toCm(raw, unit);
        fromWaist('bw-tape', cm, raw > 0 ? 'Your waist is '+raw+' '+unit+(unit==='in'?' ('+cm.toFixed(0)+' cm)':'')+'.' : '');
      });
      $('bw-all-sizes').innerHTML = waist.map(b => '<li><b>'+b.size+'</b>'+b.printed+' cm</li>').join('');
      $('bw-opt-brand').dataset.tab='bottoms';


      /* ---- Tops: band label, under bust, full bust ---- */
      const bust = DATA.bands.bust, under = DATA.bands.underbust;
      const AU_BAND = ['6','8','10','12','14','16','18','20','22'], UK_BAND = ['28','30','32','34','36','38','40','42','44'];
      const BINDER_NOTE = 'Bralettes are a relaxed fit; binders are firm. For a binder, if you\u2019re between sizes go up one. A binder should never hurt.';
      function fromBand(prefix, bands, cm, what, srcText){
        if(!(cm > 0)) { $(prefix+'-result').hidden = true; return; }
        const first = bands[0], last = bands[bands.length-1];
        if(cm < first.lo) return show(prefix,{measure:srcText, size:'Smaller than our '+first.size, note:'Our smallest top fits a '+what+' from '+first.lo+' cm.'});
        if(cm > last.hi) return show(prefix,{measure:srcText, size:'Larger than our '+last.size, note:'Our largest top fits a '+what+' up to '+last.hi+' cm.'});
        const b = bands.find(x => cm >= x.lo && cm <= x.hi);
        show(prefix,{measure:srcText, size:'Being '+b.size+'<span>'+b.lo+'-'+b.hi+' cm '+what+'</span>', note:BINDER_NOTE, cta:'Choose '+b.size, onClick:()=>select(b.size)});
      }
      // T1 band chips: AU bands and UK/US bands both map onto the under-bust bands, smallest adult first
      const adultUnder = under.filter(b => b.size !== '3XS');
      const chips = $('bw-band-chips');
      [['AU/NZ', AU_BAND],['UK/US', UK_BAND]].forEach(([region, list]) => {
        const lab = document.createElement('span'); lab.textContent = region; lab.style.cssText='font-size:13px;color:var(--bw-muted);width:100%;margin-top:6px'; chips.appendChild(lab);
        list.forEach((label, i) => {
          const b = adultUnder[i]; if(!b) return;
          const btn = document.createElement('button'); btn.type='button'; btn.className='bw-chip'; btn.textContent = label; btn.setAttribute('aria-pressed','false');
          btn.addEventListener('click', () => { chips.querySelectorAll('button').forEach(x => x.setAttribute('aria-pressed', x===btn));
            show('bw-tlabel',{measure:'A '+region+' '+label+' band fits an under bust of about '+b.lo+'-'+b.hi+' cm.', size:'Being '+b.size+'<span>'+b.lo+'-'+b.hi+' cm under bust</span>', note:'Cup size doesn\u2019t change your Being size. '+BINDER_NOTE, cta:'Choose '+b.size, onClick:()=>select(b.size)}); });
          chips.appendChild(btn);
        });
      });
      // T3 / T4
      $('bw-under-val').addEventListener('input', (e) => { const raw = parseFloat(e.target.value), unit = unitOf(e.target.closest('.bw-num').querySelector('.bw-unit')); const cm = toCm(raw, unit);
        fromBand('bw-under', under, cm, 'under bust', raw > 0 ? 'Your under bust is '+raw+' '+unit+(unit==='in'?' ('+cm.toFixed(0)+' cm)':'')+'.' : ''); });
      $('bw-bust-val').addEventListener('input', (e) => { const raw = parseFloat(e.target.value), unit = unitOf(e.target.closest('.bw-num').querySelector('.bw-unit')); const cm = toCm(raw, unit);
        fromBand('bw-bust', bust, cm, 'full bust', raw > 0 ? 'Your full bust is '+raw+' '+unit+(unit==='in'?' ('+cm.toFixed(0)+' cm)':'')+'.' : ''); });
      $('bw-all-top-sizes').innerHTML = bust.map((b,i) => '<li><b>'+b.size+'</b>'+b.lo+'-'+b.hi+' bust / '+under[i].lo+'-'+under[i].hi+' under</li>').join('');

      /* ---- Tops / bottoms switch: show the matching four options and move the converter across ---- */
      const brandBody = $('bw-brand-body');
      function setProduct(p){
        document.querySelectorAll('.bw-product button').forEach(b => b.setAttribute('aria-pressed', b.dataset.product === p));
        $('bw-set-bottoms').hidden = p !== 'bottoms'; $('bw-set-tops').hidden = p !== 'tops';
        (p === 'tops' ? $('bw-tbrand-body') : $('bw-opt-brand')).appendChild(brandBody);
        document.querySelectorAll('.bw-opt').forEach(o => o.open = false);
        BeingSizer.config.product = p; $('bw-reset').click();
        BeingSizer.config.onMeasureInstead = () => { const t = $(p === 'tops' ? 'bw-opt-under' : 'bw-opt-tape'); t.open = true; if(t.scrollIntoView) t.scrollIntoView({behavior:'smooth', block:'start'}); $(p === 'tops' ? 'bw-under-val' : 'bw-tape-val').focus(); };
      }
      document.querySelectorAll('.bw-product button').forEach(b => b.addEventListener('click', () => setProduct(b.dataset.product)));
      BeingSizer.setProduct = setProduct;   // call BeingSizer.open(); BeingSizer.setProduct('tops') from a bralette or binder page
      setProduct('bottoms');
      // One option open at a time, like the live accordion
      document.querySelectorAll('.bw-opt').forEach(d => d.addEventListener('toggle', () => { if(d.open) document.querySelectorAll('.bw-opt').forEach(o => { if(o!==d) o.open = false; }); }));
    })();
  }).catch(function(err){ console.error('[BeingSizer] could not load size data', err); });
})();
